module.exports = __webpack_public_path__ + "static/media/SmileDr-SmileHappy.ef05e25d.jpg";